import { useState, useEffect } from 'react'
import { StoresFilters } from '@/components/Stores/StoresFilters'
import { StoresGrid } from '@/components/Stores/StoresGrid'
import { Pagination } from '@/components/common/Pagination'
import { usePersistedPageSize } from '@/hooks/usePersistedPageSize'
import { TABLE_PAGE_SIZE_KEYS } from '@/stores/useTablePageSizeStore'
import { useStoresList } from '@/hooks/useStores'
import { toast } from '@/stores/useToastStore'

export default function AdminStores() {
  // Filter state
  const [searchInput, setSearchInput] = useState('')
  const [regionInput, setRegionInput] = useState('')
  const [isActive, setIsActive] = useState<'all' | 'true' | 'false'>('all')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = usePersistedPageSize(
    TABLE_PAGE_SIZE_KEYS.ADMIN_STORES_LIST,
    20
  )

  // Reset to page 1 when filters change
  useEffect(() => {
    setPage(1)
  }, [searchInput, regionInput, isActive, pageSize])

  const { data, isLoading, isError } = useStoresList({
    search: searchInput,
    region: regionInput,
    isActive,
    page,
    pageSize,
  })

  useEffect(() => {
    if (isError) {
      toast.error('Failed to load stores')
    }
  }, [isError])

  const stores = data?.data ?? []
  const total = data?.pagination.total ?? 0
  const totalPages = Math.max(1, Math.ceil(total / pageSize))

  return (
    <div className="flex flex-col gap-6 p-6">
      {/* Page Header */}
      <div>
        <h1 className="text-2xl font-semibold text-foreground">Stores</h1>
        <p className="text-base text-muted-foreground mt-1">
          Browse all stores
        </p>
      </div>

      {/* Filter Bar */}
      <StoresFilters
        searchInput={searchInput}
        onSearchChange={setSearchInput}
        regionInput={regionInput}
        onRegionChange={setRegionInput}
        isActive={isActive}
        onIsActiveChange={setIsActive}
      />

      {/* Grid */}
      <StoresGrid stores={stores} loading={isLoading} />

      {/* Pagination */}
      <Pagination
        page={page}
        pageSize={pageSize}
        totalPages={totalPages}
        onPageChange={setPage}
        onPageSizeChange={setPageSize}
      />
    </div>
  )
}
